import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
import { sortBy } from 'lodash';
import { useTranslation } from 'next-i18next';
import { IconList } from '../../../../../components/TravelDetailsOverlay/components/TravelDetails/components/IconList.js';
import { PaymentIcon } from '../../../../../components/TravelDetailsOverlay/components/TravelDetails/components/PaymentIcon.js';
import { PAYMENT_METHOD_AX, PAYMENT_METHOD_DINERS_CLUB, PAYMENT_METHOD_EC, PAYMENT_METHOD_INVOICE, PAYMENT_METHOD_PAYPAL, PAYMENT_METHOD_PAYPALLIGHT, PAYMENT_METHOD_SEPA, PAYMENT_METHOD_SOFORT, PAYMENT_METHOD_VISA } from '../../../../../components/TravelDetailsOverlay/models.js';
import { HeadlineLarge, Stack } from '../../../../../primitives/index.js';
const paymentOrder = [PAYMENT_METHOD_VISA, PAYMENT_METHOD_EC, PAYMENT_METHOD_AX, PAYMENT_METHOD_DINERS_CLUB, PAYMENT_METHOD_SEPA, PAYMENT_METHOD_INVOICE, PAYMENT_METHOD_SOFORT, PAYMENT_METHOD_PAYPAL, PAYMENT_METHOD_PAYPALLIGHT];
export const PaymentOptions = ({
  payments
}) => {
  const {
    t
  } = useTranslation('travelDetailsOverlay');
  const paymentMethodes = sortBy(payments, method => paymentOrder.indexOf(method));
  return _jsxs(Stack, {
    spacing: 1.25,
    children: [_jsx(HeadlineLarge, {
      children: t('paymentOptionsTitle')
    }), _jsx(IconList, {
      "data-testid": "shared-offerDetailsLayer-paymentMethods",
      direction: "row",
      spacing: "small",
      children: _jsx(Stack, {
        direction: "row",
        spacing: "xSmall",
        children: paymentMethodes.map(paymentMethod => _jsx(PaymentIcon, {
          paymentMethod: paymentMethod
        }, paymentMethod))
      })
    })]
  });
};